import { Component, Input, SimpleChanges } from '@angular/core';
import { ActivatedRoute, Router } from "@angular/router";
import { DataService } from '../data.service';
import { MessageService } from 'primeng/api';
import * as XLSX from 'xlsx';
import { jwtDecode } from 'jwt-decode';
import { TableModule } from 'primeng/table';
import { firstValueFrom } from 'rxjs';

@Component({ 
  selector: 'app-form-proyecto',
  templateUrl: './form-proyecto.component.html',
  styleUrls: ['./form-proyecto.component.css']
})

export class FormProyectoComponent {
  registros=[];
  columnas;
  formularios=[];
  hayRegistros: boolean = true;
  editarRegistro: boolean = false;
  idRegistro: string;
  idFormulario: string;
  Registro: any;
  crearRegistro: boolean = false;
  pagina: number = 1;
  tampag: number = 10;
  total;
  totalPaginas;
  saltar=0;
  idEncuesta;
  idProyecto;
  opciones = [];
  columnasSeleccionadas = [];
  PermisoEliminar: boolean = false;
  PermisoVer: boolean = false;
  PermisoEditar: boolean = false;
  PermisoCrear: boolean = false;
  token: any;
  permisoEncuesta: any;
  nombreproyecto;
  columnasEnOrden = [];

  constructor(public data: DataService, private route: ActivatedRoute, private router: Router, private messageService: MessageService) {

    this.ObtenerRegistros();
    //this.ObtenerCampos();

    this.establecerPermisos();
  }

  private establecerPermisos() {
    const token = sessionStorage.getItem('token');
    if (token) {
        const decodedToken: any = jwtDecode(token);
        this.token=JSON.stringify(decodedToken);
        this.permisoEncuesta = decodedToken.Permisos.find((permiso: any) => permiso.IdEncuesta == this.idEncuesta);
        var esadmin=decodedToken.Rol=="admin";

        if (this.permisoEncuesta) {
            this.PermisoEliminar = this.permisoEncuesta?.Eliminar || false;
            this.PermisoVer = this.permisoEncuesta?.Ver || false;
            this.PermisoEditar = this.permisoEncuesta?.Editar || false;
            this.PermisoCrear = this.permisoEncuesta?.Crear || false;
        }

        if (esadmin)
        {
          this.PermisoEliminar = true;
          this.PermisoVer = true;
          this.PermisoEditar = true;
          this.PermisoCrear = true;
        }
    }
  }

  filtrar()
  {

    this.ObtenerRegistros();
  }

  eliminarRegistro(IdRegistro){
    console.log('eliminar registro');
    console.log(IdRegistro);
    //confirmar eliminación
    if (!confirm('¿Está seguro de que desea eliminar este registro?')) {
      return;
    }
    this.data.EliminarRegistro(IdRegistro).subscribe(
      {
        next: (x) => {      
          console.log('Registro eliminado');
          this.ObtenerRegistros();
        },
        error: (error) => {
          console.error('Error al eliminar registro:', error);
        }
      }
    );
  }

  extraerColumnas(datos, { ordenar = false } = {}) {
    if (!Array.isArray(datos) || datos.length === 0) return [];
  
    const set = new Set();
  
    for (const fila of datos) {
      if (fila && typeof fila === "object") {
        Object.keys(fila).forEach(k => set.add(k));
      }
    }
  
    const columnas = [...set];
    return ordenar ? columnas.sort() : columnas;
  }



  async ObtenerRegistros() {
    //this.idFormulario = this.route.snapshot.paramMap.get('id');
    this.idProyecto = this.route.snapshot.paramMap.get('id');
    //alert('this.idEncuesta: ' + this.idEncuesta);
    //this.data.ObtenerRegistros(this.idEncuesta, this.columnasSeleccionadas, this.pagina, this.tampag, this.saltar).subscribe(
    this.columnasSeleccionadas=[];
    for( let formulario of this.formularios)
    {
      var colselform={formulario:formulario.Modulo, camposseleccionados: formulario.camposdefecto};
      this.columnasSeleccionadas.push(colselform);
    }

    await this.data.ObtenerProyecto(this.idProyecto, this.columnasSeleccionadas, 1, 100000, 0).subscribe(
      {
        next: async(x) => {      
          this.registros = x.registros;
          this.nombreproyecto=x.proyecto;
          
          

           for (let i = 0; i < x.formularios.length; i++) {
            
                const y = await firstValueFrom(
                this.data.ObtenerCamposXFormulario(x.formularios[i].Modulo)
                );
                // 2. Procesa el resultado
                const campos = [];
                for (const campo of y) {
                const ele = { label: campo.valor, value: campo.nombre };
                campos.push(ele);

                const nombreColumna = `F${i + 1}.${ele.label}`;
                this.columnasEnOrden.push(nombreColumna);
                }

                // 3. Guarda los campos en el formulario correspondiente
                x.formularios[i].campos = campos;

          }
          
          this.formularios=x.formularios;


          
          this.total=this.registros.length;
          this.totalPaginas= Math.ceil(this.total / this.tampag)
          console.log("================formularios================");
          console.log(this.formularios[0]);



          console.log('====================Columnas En Orden:====================');
          console.log(this.columnasEnOrden);



          console.log("================REGISTROS RECIBIDOS================");
          console.log(this.registros);
          
          this.registros=this.convertirArraysEnCadenas(this.registros);
          this.registros = this.registros.map(obj => this.aplanarObjeto(obj));



          // crear las columnas ordenadas (this.columnas) segun el orden de this.formularios campos
          this.columnas = this.extraerColumnas(this.registros);

          //ordenar this.columnas segun this.columnasEnOrden recorriendo this.columnasEnOrden y añadiendo las columnas que existan en this.columnas a un array nuevo
          this.columnas = this.columnasEnOrden.filter(columna => this.columnas.includes(columna));

          console.log("================columnas================");
          console.log(this.columnas);

          // Verifica si hay registros y toma el primer registro para definir los nombres de columna dinámicamente
          if (this.registros.length > 0) {
            this.hayRegistros = true;

          } else {
            this.hayRegistros = false;
          }
        },
        error: (error) => {
          // Si error es 404, no hay registros 
          if (error.status === 404) {
            console.log('No hay registros');
            this.hayRegistros = false;
          } else {
            console.error('Error al listar registros:', error);
          }
        }
      }
    );
  }

  ObtenerCampos(){
    this.data.ObtenerCampos(this.idEncuesta).subscribe(
      {
        next: (x) => {      
          var registros = x.registros;
          //recorrer registros para obtener los campos
          registros.forEach(element => {

            var nombrecampo=element.elementName;

            if(nombrecampo.startsWith("$$"))
            {
              nombrecampo=nombrecampo.slice(2);
            }

             var registro={label:nombrecampo, value:nombrecampo};

            this.opciones.push(registro);
          });
         
        },
        error: (error) => {
          // Si error es 404, no hay registros 
          if (error.status === 404) {
            console.log('No hay registros');
            this.hayRegistros = false;
          } else {
            console.error('Error al listar registros:', error);
          }
        }
      }
    );
  }

  cambiarPagina(event){
    console.log('==============nueva pagina==============');
    console.log(event.page);
    console.log(event);

    this.pagina=event.page;
    this.saltar=event.first;

    this.tampag=event.rows;

    this.ObtenerRegistros();
  }

  navigateToEditarRegistro(id: string) {
    console.log('Navegando a edición de registro:', id);
    this.editarRegistro = true;
    this.idRegistro = id;
    this.Registro = this.registros.find(x => x._id === id);
    console.log('Registro seleccionado:');
    console.log(this.Registro);
  }

  navigateToRegistro(idRegistro: string) {
    
    this.idRegistro = idRegistro;
    this.editarRegistro = true;

  }

  onRegistroGuardado() {
    this.editarRegistro = false; // Oculta el componente de edición
    this.crearRegistro=false;
    this.idRegistro = null;
    this.ObtenerRegistros();
    this.messageService.add({severity:'success', summary: 'Éxito', detail: 'Registro actualizado exitosamente'});
  }

  onCreacionFinalizada() {
    this.crearRegistro = false; // Oculta el componente de creación
    this.ObtenerRegistros();
  }

  onCrearRegistro() {
    this.crearRegistro = true;
  }

  onCancelarEdicion() {
    this.editarRegistro = false;
    this.crearRegistro = false;
  }

  convertirArraysEnCadenas(arr: any[]): any[] {
  if (!Array.isArray(arr)) {
    console.error("convertirArraysEnCadenas: el valor recibido no es un array", arr);
    return [];
  }

  return arr.map(obj => {
    const nuevo = { ...obj };

    for (const clave in nuevo) {
      if (!nuevo.hasOwnProperty(clave)) continue;

      const valor = nuevo[clave];

      // ✅ 1. Convertir arrays simples a cadena
      if (Array.isArray(valor) && valor.every(item => typeof item === 'string' || typeof item === 'number')) {
        nuevo[clave] = valor.join(', ');
        continue;
      }

      // ✅ 2. Detectar si el campo es una fecha (por nombre o por tipo)
      const esNombreFecha = clave.toLowerCase().includes('fecha');
      
      const esDateObject = Object.prototype.toString.call(valor) === '[object Date]';
      const esISODateString = typeof valor === 'string' && !isNaN(Date.parse(valor));

      if ((esNombreFecha || esDateObject || esISODateString) && valor) {
        const fecha = new Date(valor);
        if (!isNaN(fecha.getTime())) {
          const yyyy = fecha.getFullYear();
          const mm = String(fecha.getMonth() + 1).padStart(2, '0');
          const dd = String(fecha.getDate()).padStart(2, '0');
          nuevo[clave] = `${yyyy}-${mm}-${dd}`;
        }
      }

    }

    return nuevo;
  });
}
    aplanarObjeto(obj, prefijo = '', resultado = {}) {
  for (const key in obj) {
    if (!obj.hasOwnProperty(key)) continue;

    const valor = obj[key];
    const claveCompuesta = prefijo ? `${prefijo}.${key}` : key;

    if (valor !== null && typeof valor === 'object' && !Array.isArray(valor)) {
      // Recursivamente aplana objetos internos
      this.aplanarObjeto(valor, claveCompuesta, resultado);
    } else {
      resultado[claveCompuesta] = valor;
    }
  }
  return resultado;
  }

  async descargarExcelANTERIOR() {
    try {
      // Establece un valor alto para 'tampag' para intentar obtener todos los registros
      var todosLosRegistros = await this.data.ObtenerProyecto(this.idProyecto, this.columnasSeleccionadas, 1, 100000, 0).toPromise();

      todosLosRegistros.registros=this.convertirArraysEnCadenas(todosLosRegistros.registros);
      todosLosRegistros.registros = todosLosRegistros.registros.map(obj => this.aplanarObjeto(obj));
      
      
      const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(todosLosRegistros.registros);
      const workbook: XLSX.WorkBook = { Sheets: { 'data': worksheet }, SheetNames: ['data'] };
      XLSX.writeFile(workbook, 'resultados.xlsx');
    } catch (error) {
      console.error('Error al descargar todos los registros:', error);
    }
  }

  async descargarExcel() {
  try {
    // Obtener todos los registros del proyecto
    const todosLosRegistros = await firstValueFrom(
      this.data.ObtenerProyecto(this.idProyecto, this.columnasSeleccionadas, 1, 100000, 0)
    );

    // 1. Convertir arrays en cadenas y aplanar objetos
    let registrosProcesados = this.convertirArraysEnCadenas(todosLosRegistros.registros);
    registrosProcesados = registrosProcesados.map(obj => this.aplanarObjeto(obj));

    // 2. Reordenar campos según this.columnas (que ya tiene el orden de this.columnasEnOrden)
    const registrosOrdenados = registrosProcesados.map(registro => {
      const nuevoRegistro = {};
      this.columnas.forEach(col => {
        nuevoRegistro[col] = registro[col] !== undefined ? registro[col] : '';
      });
      return nuevoRegistro;
    });

    // 3. Crear y guardar archivo Excel
    const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(registrosOrdenados);
    const workbook: XLSX.WorkBook = { Sheets: { 'data': worksheet }, SheetNames: ['data'] };
    XLSX.writeFile(workbook, 'resultados.xlsx');
  } catch (error) {
    console.error('Error al descargar todos los registros:', error);
  }
}
}
